import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as appActions } from "../../modules/appModule"
import { COLOR } from "../../modules/constants"

import NavBar from "../../components/layout/DashboardNavbar"
import Page, { Content } from "../../components/Page"
import Footer from "../../components/Footer"

class DeleteGoodbye extends Component {

  render() {
    return (
      <Page>
        <NavBar unauthorized title="Goodbye" backLink="/" portrait={this.props.portrait} />
        <Content scroll>
          <div className="form-page">
            <div className="form-cell">
              <div className="form-wrapper">
                <p className="alternative-link" >
                  Your account has now been deleted.
                  <br /><br />Please tell us why you deleted your Numerable account by emailing us on <a href="mailto:info@numerable.io?Subject=Feedback" target="_top" style={{ color: COLOR.BRAND.STD }} >info@numerable.io</a>
                </p>
              </div>
            </div>
          </div>
        </Content>

        <Footer urlSource={this.props.urlSource} />
      </Page>
    )
  }
}

const mapStateToProps = ({ common, user }) => {
  return {
    urlSource: common.urlSource,
    portrait: user.portrait,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteGoodbye)

